module.exports = __webpack_public_path__ + "img/einvoice-info-white.d29920cc.svg";